/**
 * Projeção dos focos (lon/lat) para as coordenadas do mapa (projeção nativa
 * do GOES-19), em lote. Mesma transformação de `lonLatToMap`, mas aplicada
 * de uma vez ao vetor inteiro (bem mais rápido para dezenas de milhares de
 * pontos). Funciona também dentro do Web Worker.
 */
import { getTransform } from 'ol/proj';
import { GOES_PROJ, registerGoesProjection } from '../map/projection';
import type { FireTable } from './types';

/** Preenche `table.x`/`table.y`. Pontos além do limbo ficam não finitos. */
export function projectTable(table: FireTable): FireTable {
  registerGoesProjection();
  const n = table.length;
  if (n === 0) return table;
  const flat = new Array<number>(n * 2);
  for (let i = 0; i < n; i++) {
    flat[2 * i] = table.lon[i]!;
    flat[2 * i + 1] = table.lat[i]!;
  }
  const out = getTransform('EPSG:4326', GOES_PROJ)(flat, undefined, 2);
  for (let i = 0; i < n; i++) {
    table.x[i] = out[2 * i]!;
    table.y[i] = out[2 * i + 1]!;
  }
  return table;
}
